import { useQuery } from '@tanstack/react-query';
import { getA2AIpAllowlist } from '@/services/a2a-ip-allowlist/get-a2a-ip-allowlist';
import { A2AIpAllowlist } from '@/services/a2a-ip-allowlist/a2a-ip-allowlist-types';
import { useOrgStore } from '@/stores/org-store';

export const A2A_IP_ALLOWLIST_QUERY_KEY = 'a2a-ip-allowlist';

export const useGetA2AIpAllowlist = () => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<A2AIpAllowlist | null, Error>({
    queryKey: [A2A_IP_ALLOWLIST_QUERY_KEY, orgId],
    queryFn: () => getA2AIpAllowlist(),
    enabled: !!orgId,
    // An unconfigured allowlist returns null rather than throwing, so a thrown
    // error here is a real failure — surface it promptly instead of spending
    // the global retry backoff on it.
    retry: false,
  });
};
